import React, {Component} from 'react';
import Placeholder from 'react-bootstrap/Placeholder'
import {Card} from 'react-bootstrap';
import {connect} from 'react-redux';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimes} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from 'react-router-dom';

import * as actions from '../../../store/actions/index';
import classes from './EmployeePersonCard.module.css';
import {createMarkup, formatFio} from '../../../services/generalService';

import DefaultIcon from '../../../assets/default_photo.png'
import Image from '../../UI/ImageHolder/Image'

import {Helmet} from "react-helmet";
import data from "../../../assets/data/meta.json"

class EmployeePersonCard extends Component {
    componentDidMount() {
        let id;
        if (this.props.match) id = this.props.match.params.id;
        else id = this.props.urlId
        this.props.onGetEmployeeDetails(id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.employeeDetails && prevProps.loadingEmployeeDetails) {
            this.props.onGetEmployees(this.props.employeeDetails.lastName + " " + this.props.employeeDetails.firstName + " " + this.props.employeeDetails.middleName);
        }
        if (prevProps.serverNotFoundEntity !== this.props.serverNotFoundEntity) {
            this.props.history.push('/not-found');
        }
    }

    openProfile = () => {
        const filterQuery = `${this.props.employeeDetails.lastName}, ${this.props.employeeDetails.firstName.charAt(0)}. ${this.props.employeeDetails.middleName.charAt(0)}.`;
        window.open(`https://libeldoc.bsuir.by/simple-search?filterquery=${filterQuery}&filtername=author&filtertype=equals`);
    }

    hasContacts = () => {
        if (this.props.employeeDetails.email !== null && this.props.employeeDetails.email !== '') return true;
        for (let i = 0; i < this.props.employeeDetails.jobPositions.length; i++)
            if (this.props.employeeDetails.jobPositions[i].contacts.length !== 0) return true;
        return false;
    }

    getFormattedPhoneNumber = (phoneNumber) => {
        return phoneNumber.substr(0, 4) + ' (' + phoneNumber.substr(4, 2) + ') ' +
            phoneNumber.substr(6, 3) + '-' + phoneNumber.substr(9, 2) + '-' + phoneNumber.substr(11, 2);
    }

    addDefaultSrc = (e) => {
        e.target.src = 'https://www.google.com/s2/favicons?domain=https://www.freefavicon.com/freefavicons/software/iconinfo/icon-with-question-mark-152-28725.html&sz=16'
    }

    getJobPositionTitle = (employeeDetails) => {
        return <div className={this.hasContacts() && classes.fullWidth}>
            {(employeeDetails.jobPositions && employeeDetails.jobPositions.length !== 0)
                ? <div className={classes.sectionTitle}><b>Должность, место работы</b></div>
                : null}</div>
    }

    getRankAndDegree = (employeeDetails) => {
        return <div style={employeeDetails.degree !== '' ? {marginBottom: 15} : null} className={this.hasContacts() && classes.fullWidth}>
            {(employeeDetails.degree !== '')
                ? <div className={classes.sectionTitle}><b>Ученая степень</b></div>
                : null}
            <div style={{fontSize: 14}}>
                {employeeDetails.degree !== '' ? employeeDetails.degree : ''}
                {(employeeDetails.degree !== '' && employeeDetails.rank) ? ', ' : ''}
                {employeeDetails.rank ? employeeDetails.rank : ''}
            </div>
        </div>
    }

    getOneJobPosition = (jobPosition, department, index) => {
        if (jobPosition !== "" && department !== "") {
            return <div key={index}>{jobPosition + ', ' + department}</div>
        } else if (jobPosition !== "" && department === "") {
            return <div key={index}>{jobPosition}</div>
        } else if (jobPosition === "" && department !== "") {
            return <div key={index}>{department}</div>
        } else {
            return null;
        }
    }

    getListOfJobPositions = (jobPosition, department, index) => {
        if (jobPosition !== "" && department !== "") {
            return <li key={index}>{jobPosition + ', ' + department}</li>
        } else if (jobPosition !== "" && department === "") {
            return <li key={index}>{jobPosition}</li>
        } else if (jobPosition === "" && department !== "") {
            return <li key={index}>{department}</li>
        } else {
            return null;
        }
    }

    getJobPositions = (employeeDetails) => {
        return <div style={{fontSize: 14}}>
            {employeeDetails.jobPositions.length === 1
                ? <div className={this.hasContacts() && classes.fullWidth}>
                    {employeeDetails.jobPositions.map((el, index) =>
                        this.getOneJobPosition(el.jobPosition, el.department, index)
                    )}
                </div>
                : <div>
                    <ul>
                        {employeeDetails.jobPositions.map((el, index) =>
                            this.getListOfJobPositions(el.jobPosition, el.department, index)
                        )}
                    </ul>
                </div>
            }
        </div>
    }

    checkIfContactsIsEmpty = (jobPositions) => {
        const contactsExist = jobPositions.filter(job => job.contacts.length > 0);
        return contactsExist.length > 0;
    }

    render() {
        let detailsComponent = null
        if (this.props.loadingEmployeeDetails)
            detailsComponent = <React.Fragment>
                <div className={classes.header}>
                </div>
                <Card style={{ width: '100%', height: 'calc(100% - 70px)' }}>
                    <Card.Img variant="text-center" src={DefaultIcon} className={classes.imageContainer} />
                    <Card.Body>
                        <Placeholder as={Card.Title} animation="glow">
                            <Placeholder xs={6} />
                        </Placeholder>
                        <Placeholder as={Card.Text} animation="glow">
                            <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={8} />{' '}
                            <Placeholder xs={6} /> <Placeholder xs={8} />
                            <Placeholder xs={9} /> <Placeholder xs={8} />
                            <Placeholder xs={4} /> <Placeholder xs={8} />
                        </Placeholder>
                    </Card.Body>
                </Card>
            </React.Fragment>
        if (!this.props.loadingEmployeeDetails && !this.props.loadingEmployees && this.props.employeeDetails)
            detailsComponent = <div>
                <div className={classes.header}>
                    <div>{formatFio(this.props.employeeDetails)}</div>
                    {(this.props.ifModal) ? <button onClick={this.props.closeClicked}><FontAwesomeIcon icon={faTimes} size="lg" color="#FFFFFF" /></button> : null}
                </div>
                <div className={classes.imageContainer}>
                    <Image size={250} src={this.props.employeeDetails.photoLink} fallbackSrc={DefaultIcon}
                           radius={200}/>
                </div>

                <div className={classes.details}>
                    <div className={`${classes.info} ${this.hasContacts() && classes.verticalDivider}`}>
                        <div className={classes.jobPosition}>
                            <div className={classes.personalInformationContainer}>
                                {this.getRankAndDegree(this.props.employeeDetails)}

                                {this.getJobPositionTitle(this.props.employeeDetails)}
                                <div>
                                    {(this.props.employeeDetails.jobPositions && this.props.employeeDetails.jobPositions.length !== 0)
                                        ? this.getJobPositions(this.props.employeeDetails)
                                        : null}
                                </div>
                            </div>
                        </div>

                        {this.hasContacts() && <hr className={classes.jobDivider}/>}

                        <div className={classes.contactsGrid}>
                            {(this.hasContacts()) ?
                                <React.Fragment>
                                    <div className={classes.fullWidth}>
                                        <div className={classes.sectionTitle}>Контакты</div>
                                        <div style={{fontSize: 14}}>
                                            {this.props.employeeDetails.email &&
                                                <div>Почта: <a href={`mailto:${this.props.employeeDetails.email}`}
                                                               className={classes.underline}>{this.props.employeeDetails.email}</a>
                                                </div>}
                                            <div style={{width: "100%", marginTop: "5px"}}>
                                                {this.checkIfContactsIsEmpty(this.props.employeeDetails.jobPositions) && <div>Рабочий телефон: </div>}
                                                {this.props.employeeDetails.jobPositions.map((position) =>
                                                    <ul style={{paddingLeft: "30px"}}>
                                                        {position.contacts.map((contact) =>
                                                            <li className={classes.contact} key={contact.phoneNumber}>
                                                                <div style={{width: "100%"}}>
                                                                    <a href={`tel: ${contact.phoneNumber}`}
                                                                       className={classes.underline}>{this.getFormattedPhoneNumber(contact.phoneNumber)}</a>
                                                                </div>
                                                                <div style={{
                                                                    marginBottom: "10px",
                                                                    width: "100%"
                                                                }}>{contact.address}</div>
                                                            </li>
                                                        )}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment> : null}
                        </div>

                    </div>

                    <hr/>

                    <div>
                        <div className={classes.sectionTitle}>Ссылки на профили</div>
                        <ul>
                            {this.props.employees.length !== 0 ?
                                <li className={classes.contact}>
                                    <span><img width="27px" src={process.env.PUBLIC_URL + '/favicon.ico'} alt="Employee schedule" /></span>
                                    <NavLink to={`/schedule/${this.props.employeeDetails.urlId}`} className={classes.underline}>
                                        Расписание
                                    </NavLink>
                                </li> : ""
                            }
                            <li className={classes.contact}>
                                <span><img width="25px" src="https://libeldoc.bsuir.by/favicon.ico" alt="Profile link favicon" /></span>
                                <span onClick={this.openProfile} className={classes.underline}>Репозиторий БГУИР</span>
                            </li>
                            {this.props.employeeDetails.profileLinks.map((link) =>
                                <li className={classes.links} key={link.profileLinkType}>
                                    <div style={{marginBottom: 10}}>
                                        <img width="25px" src={`https://www.google.com/s2/favicons?domain=${link.link}`}
                                             alt="Profile link favicon" onError={this.addDefaultSrc}/>
                                        <a href={link.link} target="_blank" rel="noreferrer"
                                           className={classes.underline}>{link.profileLinkType}</a>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>

                    <div>
                        {(this.props.employeeDetails.readingCourses.length !== 0) ?
                            <React.Fragment>
                                <hr />
                                <div className={classes.sectionTitle}>Читаемые курсы</div>
                                <ul>
                                    {this.props.employeeDetails.readingCourses.map((course) =>
                                        <li key={course}>{course}</li>
                                    )}
                                </ul>
                            </React.Fragment> : null}
                    </div>
                    {
                        (this.props.employeeDetails.additionalInformation.length !== 0) ?
                            <React.Fragment>
                                <hr />
                                {this.props.employeeDetails.additionalInformation.map((el, index) =>
                                    <div key={index} className={classes.additionalInformation}>
                                        <div className={classes.sectionTitle}>{el.nameType}</div>
                                        <div dangerouslySetInnerHTML={createMarkup(el.content)}></div>
                                    </div>)}
                            </React.Fragment> : null
                    }
                </div>
            </div>

        return (
            <React.Fragment>
                <Helmet>
                    <title>
                        {
                        this.props.serverNotFoundEntity ? '' : 
                        (this.props.employeeDetails ? formatFio(this.props.employeeDetails) : ''
                        + ((this.props.employeeDetails?.degreeAbbrev || this.props.employeeDetails?.rank) ? ' (' : '')
                        + this.props.employeeDetails?.degreeAbbrev
                        + (this.props.employeeDetails?.rank ? ', ' : '')
                        + (this.props.employeeDetails?.rank ? this.props.employeeDetails.rank : '')
                        + ((this.props.employeeDetails?.degreeAbbrev || this.props.employeeDetails?.rank) ? ')' : '')
                        + data[11].title)
                        }
                    </title>
                    <meta name="description"
                        content={this.props.employeeDetails ? formatFio(this.props.employeeDetails) : ''
                            + ((this.props.employeeDetails?.degreeAbbrev || this.props.employeeDetails?.rank) ? ' (' : '')
                            + this.props.employeeDetails?.degreeAbbrev
                            + (this.props.employeeDetails?.rank ? ', ' : '')
                            + (this.props.employeeDetails?.rank ? this.props.employeeDetails.rank : '')
                            + ((this.props.employeeDetails?.degreeAbbrev || this.props.employeeDetails?.rank) ? ')' : '')
                            + data[11].description
                                .replace("DDDDDD",
                                    this.props?.employeeDetails && (this.props.employeeDetails.jobPositions && this.props.employeeDetails.jobPositions.length !== 0) ? `${this.props.employeeDetails.jobPositions[0].jobPosition}. ` : '')
                                .replace("PPPPPP",
                                    this.props?.employeeDetails && (this.props.employeeDetails.jobPositions && this.props.employeeDetails.jobPositions.length !== 0) ? ` Рабочее место: ${this.props.employeeDetails.jobPositions[0].department}, ` : '')
                                .replace("TTTTTT",
                                    this.props?.employeeDetails && (this.props.employeeDetails.jobPositions && this.props.employeeDetails.jobPositions.length !== 0 && this.props.employeeDetails.jobPositions[0].contacts.length !== 0) ? `Рабочий телефон: ${this.getFormattedPhoneNumber(this.props.employeeDetails.jobPositions[0].contacts[0].phoneNumber)}.` : '')} />
                </Helmet>
                <div className={(this.props.match) ? classes.centeredContainer : classes.container}>
                    {detailsComponent}
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        employeeDetails: state.employees.employeeDetails,
        loadingEmployeeDetails: state.employees.loadingEmployeeDetails,
        loadingEmployees: state.schedule.loadingEmployees,
        employees: state.schedule.employees,
        serverNotFoundEntity: state.employees.serverNotFoundEntity
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetEmployeeDetails: (urlId) => dispatch(actions.getEmployeeDetails(urlId)),
        onGetEmployees: (text) => dispatch(actions.getEmployees(text)),
        onShowMessage: (type, message) => dispatch(actions.setMessage({type: type, text: message}))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeePersonCard);